import React from 'react';
import {Link} from 'react-router-dom';
import Dropdown from 'rc-dropdown';
import Menu, {Item as MenuItem} from 'rc-menu';
import PropTypes from 'prop-types';

import 'rc-dropdown/assets/index.css';
import './masthead.scss';

export default class Masthead extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      activeRoute: props.activeRoute,
      user: props.user,
    };

    this._navItems = props.items || [];
    this._profileItems = props.menuItems || [];
  }

  componentWillReceiveProps({activeRoute}) {
    if (typeof activeRoute === 'string') {
      this.setState({activeRoute});
    }
  }

  getNavComponents(classPrefix = 'masthead') {
    const activeRoute = this.state.activeRoute;
    const navItems = this._navItems;
    const navComponents = [];

    // construct nav components
    for (const [idx, item] of navItems.entries()) {
      let baseClass = 'masthead__li';
      const iconClass = `${classPrefix}__icon ion-${item.icon}`;

      if (activeRoute === item.route) {
        baseClass += ` ${classPrefix}__li--active`;
      }

      navComponents.push(
        <li key={idx} className={baseClass}>
          <Link to={`/${item.route}`}>
            <span className={iconClass}></span>
            {item.title}
          </Link>
        </li>
      );
    }

    return navComponents;
  }

  getProfileComponents() {
    const navComponents = [];
    const items = this._profileItems;

    for (const [idx, item] of items.entries()) {
      const iconClass = `dropdown__icon ion-${item.icon}`;

      navComponents.push(
        <MenuItem key={idx} className="dropdown__li">
          <span className={iconClass}></span>
          <span className="dropdown__title">{item.title}</span>
        </MenuItem>
      );
    }
    return navComponents;
  }

  getLogoComponent(classPrefix = 'masthead') {
    const baseClass = `logo-square ${classPrefix}__logo`;
    return (
      <Link className={baseClass} to="/">
        <img src="/assets/img/bd-logo-dark-light-bg.svg" alt="Blackdove Logo" />
      </Link>
    );
  }

  render() {
    const user = this.state.user;
    const image = (user && user.media && user.media.images ? user.media.images.avatar.low : null);
    const givenName = user ? user.givenName : '';

    const menu = (
      <Menu className="dropdown" onClick={({key}) => this._profileItems[key].onClick()}>
        {this.getProfileComponents()}
      </Menu>
    );

    return (
      <header className="masthead">
        {this.getLogoComponent()}
        <nav className="masthead__nav">
          <ul className="list--inline">
            {this.getNavComponents()}
          </ul>
        </nav>
        <Dropdown
          trigger={['click']}
          overlay={menu}
        >
          <div className="masthead__profile">
              <div className="masthead__profile--name">
                <div>Hi, {givenName}</div>
              </div>
              <div className="masthead__profile--avatar" style={{backgroundImage: `url(${image})`}}></div>
          </div>
        </Dropdown>
      </header>
    );
  }

}

Masthead.propTypes = {
  activeRoutes: PropTypes.array,
};
